module.exports = __webpack_public_path__ + "img/help-1.en.7d5dab90.jpg";